import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  getModuleNavigation,
  ModuleNavigationType,
} from 'services/moduleNavigation';
import { useFeatureAccess } from 'helpers/serviceTierHooks';

import FBOMaterialsNavigation from './components/MaterialsNavigation/FBOMaterialsNavigation';
import FBOPurchaseNavigation from './components/PurchaseNavigation/FBOPurchaseNavigation';
import FBOSalesNavigation from './components/SalesNavigation/FBOSalesNavigation';

const ModuleNavigation: React.FC<{}> = () => {
  const { type, navigationItems } = useSelector(getModuleNavigation);
  const { canAccessSales, canAccessPurchasing, canAccessReports } =
    useFeatureAccess();
  const location = useLocation();

  // Don't render navigation at all if the user doesn't have access to the current module
  if (
    (type === ModuleNavigationType.Sales && !canAccessSales) ||
    (type === ModuleNavigationType.Purchase && !canAccessPurchasing) ||
    (type === ModuleNavigationType.Materials &&
      location.pathname.includes('reports') &&
      !canAccessReports)
  ) {
    return null;
  }

  // Render the appropriate navigation component based on the current module
  switch (type) {
    case ModuleNavigationType.Sales:
      return <FBOSalesNavigation items={navigationItems} />;
    case ModuleNavigationType.Purchase:
      return <FBOPurchaseNavigation items={navigationItems} />;
    case ModuleNavigationType.Materials:
      return <FBOMaterialsNavigation items={navigationItems} />;
    default:
      return null;
  }
};

export default memo(ModuleNavigation);
